import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {reposListAppBuilder} from './config/app-builder'
import {orgReposPageRoute} from './routes/org-repos-page-route'
import {OrgReposPageForDataRouter} from './routes/OrgReposPage'

export const reposListApp = reposListAppBuilder.createDataRouterAppFromRoutes([
  orgReposPageRoute.toRoute({Component: OrgReposPageForDataRouter}),
])
registerDataRouterApp(reposListApp)
